import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, Query } from 'utility-ts-orm';
import { MajorCourseMapCourse } from '../builders/major_course_map_course_builder';
import { IMajorCourseMap } from '../builders/major_course_map_program_builder';
import { MajorCourseMapProgram } from '../builders/major_course_map_program_builder';

export class MajorCourseMapQuery implements IQuery {
  private __result: IMajorCourseMap[];

  constructor(
    private ngMajorCourseMapProgramDatastore: IDatasource<MajorCourseMapProgram>,
    private ngMajorCourseMapCourseDatastore: IDatasource<MajorCourseMapCourse>
  ) {
    Query.registerQuery(this, this.ngMajorCourseMapProgramDatastore, this.ngMajorCourseMapCourseDatastore);
  }

  run(): this {
    this.__result = this.createCourseMap();
    return this;
  }

  get result() {
    return this.__result;
  }

  createCourseMap(): IMajorCourseMap[] {
    const programSlot: MajorCourseMapProgram[] = _4.sortBy(
      this.ngMajorCourseMapProgramDatastore.values(),
      (_programSlot: MajorCourseMapProgram) => _programSlot.slot
    );

    return _4.map(programSlot, (program_slot: MajorCourseMapProgram) => {
      const courseMapObject: IMajorCourseMap = {} as IMajorCourseMap;
      if (_4.size(program_slot.courses) === 1) {
        const course: MajorCourseMapCourse = _4.find(
          this.ngMajorCourseMapCourseDatastore.values(),
          (_course: MajorCourseMapCourse) => _course.id === _4.get(_4.first(program_slot.courses), 'course_id', 0)
        );
        courseMapObject.isGroup = false;
        courseMapObject.title = course.title;
        courseMapObject.code = course.cd;
        courseMapObject.nk = course.nk;
        courseMapObject.description = course.desc;
        courseMapObject.credits = course.credits;
        courseMapObject.hasPreReq = course.has_prereq;
        courseMapObject.hasCoReq = course.has_coreq;
      } else {
        courseMapObject.isGroup = true;
        courseMapObject.code = '';
        courseMapObject.title = program_slot.desc;
        courseMapObject.description = program_slot.desc;
        courseMapObject.hasPreReq = false;
        courseMapObject.hasCoReq = false;
      }
      return courseMapObject;
    });
  }
}

angular.module('major-explorer-data').service('ngMajorCourseMapQuery', MajorCourseMapQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/queries/major_course_map_query.ts